<template>
  <div class="exposureZonesContainer">
    <!-- The CertCapture Ecommerce Plugin Container -->
    <div
      v-show="certCaptureIsLoaded"
      id="form_container"
      class="form_container"
    />
    <!-- The initial state selection form -->
    <div
      v-show="!certCaptureIsLoaded"
      class="flexBoxCentered stateSelectionForm"
    >
      <div class="flexBox flexBoxSpreadColumn stateSelectionFormInner">
        <div>
          <h2>Add a New Certificate</h2>
          <p
            v-if="loadingExposureZones"
            class="marginSmallTop"
          >
&nbsp;
          </p>
          <p
            v-else-if="exposureZoneIsLocked"
            class="marginSmallTop"
          >
            You will be claiming exemption from sales tax in {{ formValues.state }}
          </p>
          <p
            v-else
            class="marginSmallTop"
          >
            In which state are you tax-exempt?
          </p>
        </div>
        <div class="exposureZonesContainer">
          <div
            v-show="loadingExposureZones"
            class="textCenter tinyForm"
          >
            <span class="loading inlineBlock" />
          </div>
          <select
            v-show="!loadingExposureZones"
            v-model="formValues.state"
            :disabled="exposureZoneIsLocked"
            required
          >
            <option value="">
              Select a state
            </option>
            <option
              v-for="zone in exposureZones"
              :key="zone.name"
              :value="zone.name"
            >
              {{ zone.name }}
            </option>
          </select>
        </div>
        <div
          v-show="!loadingCertCapture"
          class="exposureZonesContainer"
        >
          <button
            class="marginSmallTop cancelButton blockButton borderlessButton"
            :disabled="formValues.state === ''"
            @click="buttonClick"
          >
            Add Certificate
          </button>
        </div>
        <div
          v-show="loadingCertCapture"
          class="exposureZonesContainer"
        >
          <button
            class="marginSmallTop cancelButton blockButton borderlessButton"
          >
            <div class="loading inlineBlock" />
          </button>
        </div>
        <div v-show="certCaptureError">
          <p class="redText">
            {{ certCaptureError }}
          </p>
        </div>
      </div>
      <div
        v-if="!centered"
        class="flexBox flexBoxSpreadColumn"
      />
      <div
        v-if="!centered"
        class="flexBox flexBoxSpreadColumn"
      />
    </div>
  </div>
</template>

<script>
import CertCaptureMixin from '@/mixins/CertCaptureMixin.js'

/**
 * The CertCapture Form Component
 * @displayName CertCapture Form
 */
export default {
	name: 'CertCaptureComponent',
	components: {},
	mixins: [CertCaptureMixin],
	props: ['onSuccess', 'centered', 'destination'],
	data () {
		return {
			GenCert: window.GenCert,
			formValues: {
				state: 'North Carolina'
			},
			exposureZones: [],
			loadingExposureZones: false,
			loadingCertCapture: false,
			certCaptureIsLoaded: false,
			certCaptureError: '',
			exposureZoneIsLocked: false
		}
	},
	computed: {
		customer: function () {
			return this.$store.getters.customer
		}
	},
	mounted () {
		// We need states (exposure zones)
		this.getExposureZones()
	},
	methods: {
		/**
     * Gets called when user clicks Add Certificate button.
     *
     * @public
     */
		buttonClick: function () {
			// If the customer is blacklisted we can't add a certificate
			if (this.customer && this.customer.whiteblacklist === 'blacklist') {
				this.certCaptureError = 'Unable to edit account. Please contact the office at (919) 644-1243.'
				return
			}
			this.certCaptureError = ''
			this.launchCertCapture()
		},
		/**
     * Gets called when this component mounts. Will fetch list of exposure zones from API.
     *
     * @public
     */
		getExposureZones: function () {
			var apiPayload = {}
			apiPayload.apiEndpoint = 'customer'
			apiPayload.postData = {}
			apiPayload.postData.action = 'get_exposure_zones'
			this.loadingExposureZones = true
			this.$store
				.dispatch('apiCall', apiPayload)
				.then(response => {
					this.exposureZones = response.data.payload.response
					// If we were passed a destination, set formValues.state to it
					// and lock the dropdown
					if (this.destination) {
						const forcedExposureZone = this.exposureZones.reduce((zone, currentIteration) => {
							return currentIteration.region === this.destination ? currentIteration.name : zone
						}, null)
						if (forcedExposureZone) {
							this.formValues = {
								state: forcedExposureZone
							}
							this.exposureZoneIsLocked = true
						}
					}
				})
				.finally(() => {
					this.loadingExposureZones = false
				})
		},
		/**
     * Gets called when user clicks Add Certificate button.
     *
     * @public
     */
		launchCertCapture: function () {
			this.loadingCertCapture = true
			this.$store.dispatch('getECommerceToken').then(token => {
				if (this.GenCert && token) {
					this.initializePlugin(
						this.GenCert,
						document.getElementById('form_container'),
						{
							token: token,
							customer_number: this.customer ? this.customer.customer_id : '',
							ship_zone: this.formValues.state,
							primary_color: '#33a5ff',
							secondary_color: '#202020',
							show_files: true,
							submit_to_stack: false,
							edit_purchaser: true,
							fill_only: true,
							onCertSuccess: this.onCertSuccess,
							onManualSubmit: () => {
								// this.GenCert.hide()
								// this.onCertSuccess()
							},
							afterShow: () => {
								this.loadingCertCapture = false
								this.certCaptureIsLoaded = true
							},
							returnToJurisdiction: () => {
								// console.log('return to jurisdiction')
							},
							onNotNeeded: () => {
								/**
                 * When certificate is not needed for selected state, GenCert shows an 'OK' button,
                 * which when clicked has an error: parent.returnToJurisdiction is not a function
                 * As workaround, hide gen cert, show custom message
                 */
								this.GenCert.hide()
								this.certCaptureIsLoaded = false
								this.formValues.state = ''
								this.certCaptureError =
                  'There are no associated exemption reasons available for the selected region.'
							},
							onCancel: () => {
								// console.log('cancelled')
							},
							onCertFailure: () => {
								// console.log('cert failed')
							},
							onValidateFailure: () => {
								// console.log('validate failed')
							}
						}
					)
					this.GenCert.show()
				} else {
					console.log('Could not init GenCert')
				}
			})
		},
		/**
     * Gets called when CertCaptureFormComponent receives a successful cetificate
     * creation event. Will call API to update customer exemption status in JoeFlex.
     *
     * @public
     */
		onCertSuccess: function () {
			// Update customer record with tax exempt number
			this.$store.dispatch('updateExemptionStatus')

			// Fire off callback we were passed
			if (typeof this.onSuccess === 'function') {
				this.onSuccess(this.GenCert.certificateIds)
			}
		}
	}
}
</script>

<style scoped>
select,
.tinyForm {
  max-width: 300px;
}
.exposureZonesContainer {
  width: 100%;
}
.stateSelectionForm {
  min-height: 60vh;
}
.stateSelectionFormInner {
  max-width: 320px;
  margin: 0 auto;
  text-align: center;
}
.inlineBlock {
  display: inline-block;
}
.redText {
  color: red;
}
h1 {
  white-space: nowrap;
}
</style>
